import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import SiteHeader from "@/components/layout/SiteHeader";
import Hero from "@/components/landing/Hero";
import BrandLogoStrip from "@/components/landing/BrandLogoStrip";
import Categories from "@/components/landing/Categories";
import Manifesto from "@/components/landing/Manifesto";
import Testimonials from "@/components/landing/Testimonials";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import { Toaster } from "@/components/ui/sonner";

function LandingScrollSync() {
  const { hash } = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    if (!lenis) return;

    if (hash) {
      const id = hash.replace(/^#/, "");
      const target = id ? document.getElementById(id) : null;
      if (target) {
        lenis.scrollTo(target, { immediate: true });
        return;
      }
    }

    lenis.scrollTo(0, { immediate: true });
  }, [hash, lenis]);

  return null;
}

export const LandingPage = () => (
  <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
    <LandingScrollSync />
    <div className="bg-white text-vg-ink relative overflow-x-clip">
      <div className="noise-overlay" />
      <SiteHeader />
      <main>
        <Hero />
        <BrandLogoStrip />
        <Categories />
        <Manifesto />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  </ReactLenis>
);

export default LandingPage;
